module.exports = __webpack_public_path__ + "media/usp-personalize-c6413210.svg";